/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { CourseStudent } from './courseStudent';

export type GenericApiResponseCourseStudentData = CourseStudent | null;
